import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PanelContainer } from '../../common/panel/PanelContainer'
import { SelectCurrencyUnit } from '../../common/selectCurrencyUnit'
import { SCREEN } from '../../common/selectCurrencyUnit/constant'
import { changeAllowSetDefaultUnit } from '../../common/selectCurrencyUnit/slice'
import { Layout } from '../Layout'
import { CompanyInfo } from '../common/header/companyInfo'
import { selectCompanyInfo } from '../common/header/companyInfo/store/slice'
import { Filter } from '../common/header/filterBar'
import { PanelItem } from './PanelItem'
import { Declaration } from './declaration'
import { PANEL_DATA } from './helper'
import { Highlight } from './highlight'
import './lang/i18n'
import { resetStore, selectLoading } from './store/slice'
import {
  getHighlight,
  getOverdueSocialInsurance,
  getOverdueTaxDebt,
} from './store/thunk'

const FilingStatus = () => {
  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)
  const { organizationId } = useSelector(selectCompanyInfo)
  const isLoadingAll = useSelector(selectLoading())

  useEffect(() => {
    if (!organizationId) return
    const params = { OrganizationId: organizationId }
    dispatch(getHighlight(params))
    dispatch(getOverdueTaxDebt(params))
    dispatch(getOverdueSocialInsurance(params))
  }, [locale, organizationId])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  useEffect(() => {
    if (!isLoadingAll) {
      dispatch(
        changeAllowSetDefaultUnit({
          screen: SCREEN.FILING_STATUS,
          value: false,
        }),
      )
    }
  }, [isLoadingAll])

  const renderBottomComponent = () => {
    return (
      <>
        <Highlight />
        <Declaration />
        <PanelContainer>
          {PANEL_DATA.map((item) => (
            <PanelItem key={item.id} item={item} />
          ))}
        </PanelContainer>
      </>
    )
  }

  const renderStickyComponent = () => (
    <Filter
      renderRight={() => <SelectCurrencyUnit screen={SCREEN.FILING_STATUS} />}
    />
  )

  return (
    <Layout
      renderTopComponent={() => <CompanyInfo />}
      renderStickyComponent={renderStickyComponent}
      renderBottomComponent={renderBottomComponent}
      isLoadingContent={isLoadingAll}
      isShowFooter={false}
    />
  )
}

export default FilingStatus
